const Vue = require('vue')
const Router = require('vue-router')

Vue.use(Router)


const base = "/news"

module.exports = new Router({
	mode: 'history',
	routes: [
		{
			name     : 'index',
			path     : `${base}`,
			component: require('./components/index.vue')
		},
		{
			name     : 'news',
			path     : `${base}/:id`,
			component: require('./components/item.vue')
		},
		{
			name     : 'temp-2016-12-20-A',
			path     : `${base}/temp/2016-12-20/A`,
			component: require('./temp/2016-12-20/a.vue')
		},
		{
			name     : 'temp-2016-12-20-B',
			path     : `${base}/temp/2016-12-20/B`,
			component: require('./temp/2016-12-20/b.vue')
		},
		{
			name: "temp-2017-01-05",
			path: `${base}/temp/2017-01-05`,
			component: require('./temp/2017-01-05.vue')
		},
	],
})



// WEBPACK FOOTER //
// ./src/router.js